<template>
  <div class="container">
    <div class="search">
      <input type="text" v-model="keyword" placeholder="输入关键字搜索" @keyup.enter="search">
      <img src="../../assets/search.webp" alt="search" @click="search">
    </div>
    <div class="content">
      <div class="item" v-for="(item, index) in list" @click="toDetail(item)">
        <img :src="item.imageInfo.imageList[0].url" alt="图片">
        <!-- {{item.shopInfo.shopName}} -->
        <div class="name">
          {{item.skuName}}
        </div>
        <div class="price-coupon">
          <span class="price">¥{{item.priceInfo.lowestPrice}}</span>
          <span class="coupon">{{item.priceInfo.lowestPrice}}</span>
        </div>
        <!-- {{item.couponInfo.couponList[0].discount}} -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keyword: '',
      list: []
    }
  },
  methods: {
    search() {
      this.$ddxGet('/poetryapi/coupon/jd/query_goods', {apikey: 'hcavvhaFUfK9Mt28gNPWGSCupS5GkOOq', keyword: this.keyword}).then(res => {
        console.log(res);
        if (res) {
          this.list = res;
        }
      }).catch(e => {
        alert("服务异常");
      });
    },
    toDetail(goods) {
      this.$ddxGet('/poetryapi/coupon/jd/by_unionid_promotion', {apikey: 'hcavvhaFUfK9Mt28gNPWGSCupS5GkOOq', materialId: goods.materialUrl, unionId: 'TODO'}).then(res => {
        console.log(res);
        if (res) {
          location.href = res.clickURL;
        }
      }).catch(e => {
        alert("服务异常");
      });
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  .search {
    width: 90%;
    margin: 12px 12px 0 12px;
    background: #FFFFFF;
    border-radius: 6px;
    height: 42px;
    display: flex;
    box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);
    -webkit-box-shadow: 0 1px 3px 1px rgba(0,0,0,.14);

    input {
      flex: 1;
      background: rgba(00, 00, 00, 0);
      border: none;
      padding: 3px 12px;
    }
    input:focus{
      outline: none;
    }
    img {
      width: 30px;
      height: 30px;
      padding: 6px;
    }
  }

  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;

    .item {
      width: 169.5px;
      margin-top: 12px;
      background: #FFFFFF;
      border-radius: 6px;

      img {
        width: 100%;
        height: 169.5px;
      }
      .name {
        padding: 3px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-size: 10px;
      }
      .price-coupon {
        padding: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .price {
          font-size: 12px;
          color: #dd1a21;
        }
        .coupon {
          font-size: 12px;
          color: #dd1a21;
        }
      }
    }
  }
}
</style>
